import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogContent,
  Grid,
  LinearProgress,
  MenuItem,
  Paper,
  TextField,
  Typography,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import axios from 'axios';
import React, { useContext, useEffect, useState } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import StarIcon from '@material-ui/icons/Star';
import RefreshToken from 'routes/partials/RefreshToken';
import { AuthContext } from '@jumbo/components/context/AuthContext';
import AddIcon from '@material-ui/icons/Add';
import { LoadingButton } from '@mui/lab';
import { useSnackbar } from 'notistack';

const useStyles = makeStyles(theme => ({
  titleStyle: {
    marginBottom: '1rem',
  },
  inputStyle: {
    [`& .MuiOutlinedInput-root`]: {
      borderRadius: 25,
    },
    [`& fieldset`]: {
      borderRadius: 25,
    },
  },
  inner: {
    display: 'flex',
    alignItems: 'center',
  },
  buttonStyle: {
    borderRadius: '25px',
  },
  dialogStyle: {
    width: '400px',
  },
}));
const BaseCurrencyConversion = () => {
  const classes = useStyles();
  const { login, glob_pay_admin_auth, logout } = useContext(AuthContext);

  const [allCountry, setAllCountry] = useState([]);
  const [baseCurrency, setBaseCurrency] = useState('');
  const [currency, setCurrency] = useState('');
  const [loading, setLoading] = useState(false);
  const [addDialog, setAddDialog] = useState(false);

  const [sourceCurrency, setSourceCurrency] = useState('');
  const [usdToSourceRate, setUsdToSourceRate] = useState('');
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const handleSnakbarOpen = (msg, vrnt) => {
    let duration;
    if (vrnt === 'error') {
      duration = 3000;
    } else {
      duration = 1000;
    }
    enqueueSnackbar(msg, {
      variant: vrnt,
      autoHideDuration: duration,
    });
  };

  const openAddDialog = () => {
    setAddDialog(true);
  };

  const closeAddDialog = () => {
    console.log('closeAddDialog');
    setAddDialog(false);
  };

  const getCountry = async () => {
    await axios
      .get(`/api/v1/public/countries`)
      .then(function(response) {
        setAllCountry(response.data.data);
      })
      .catch(function(error) {
        // handle error
        console.log(error);
        // setMessage(error.response && error.response.data && error.response.data.error);
      });
  };

  const handleCurrency = async currency => {
    setLoading(true);
    setBaseCurrency(currency);

    try {
      let token = await RefreshToken(glob_pay_admin_auth, logout, login);

      let response = await axios({
        url: `/api/v1/private/currency/${currency}/all`,
        method: 'get',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      let rate = response.data.data.rates;

      let allRates = Object.entries(rate);

      setCurrency(allRates);
    } catch (error) {
      console.log('error', error);
    }
    setLoading(false);
  };

  const handleSubmit = async e => {
    setLoading(true);

    let token = await RefreshToken(glob_pay_admin_auth, logout, login);

    let data = {
      sourceCurrency,
      usdToSourceRate,
    };
    try {
      let response = await axios({
        url: `/api/v1/private/currency-conversion-rate`,
        method: 'post',
        data: data,
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      console.log(' response', response);

      closeAddDialog();
      handleSnakbarOpen(response.data.message, 'success');
    } catch (error) {
      handleSnakbarOpen(error.response.data.errors.toString(), 'error');
      setLoading(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    getCountry();
  }, []);

  return (
    <React.Fragment>
      <Grid container alignItems="center" className={classes.titleStyle} spacing={3}>
        <Grid item md={8}>
          <Typography variant="h2">Currency Base Rate</Typography>
        </Grid>
        <Grid item md={4} style={{ textAlign: 'right' }}>
          <Button
            className={classes.buttonStyle}
            variant="contained"
            color="primary"
            onClick={openAddDialog}
            startIcon={<AddIcon />}>
            Add New
          </Button>
        </Grid>
      </Grid>
      <Grid container className={classes.titleStyle} spacing={10}>
        <Grid item md={4}>
          <Typography variant="body1">
            <TextField
              variant="outlined"
              select
              label="Base Currency"
              size="small"
              fullWidth
              required
              value={baseCurrency}
              onChange={e => handleCurrency(e.target.value)}
              className={`${classes.marginStyle} ${classes.inputStyle}`}>
              {allCountry.map((e, index) => (
                <MenuItem value={e.currency} key={index}>
                  <Box className={classes.inner}>
                    <img src={e.flag} style={{ maxWidth: 24, marginRight: 10 }} alt="" /> {e.currency}
                  </Box>
                </MenuItem>
              ))}
            </TextField>
          </Typography>
        </Grid>
        <Grid item md={8}>
          {loading && <LinearProgress />}
          {currency.length > 0 && (
            <Paper>
              <List component="nav" className={classes.root} aria-label="contacts">
                {currency.map((e, index) => (
                  <ListItem button>
                    <ListItemIcon>{e[0]}</ListItemIcon>
                    <ListItemText primary={e[1]} />
                  </ListItem>
                ))}
              </List>
            </Paper>
          )}
        </Grid>
      </Grid>

      <Dialog
        open={addDialog}
        onClose={closeAddDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description">
        <DialogContent className={classes.dialogStyle}>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 20,
              height: '300px',
            }}>
            <Typography variant="h2" sx={{ textAlign: 'center' }}>
              Add New Conversion Rate
            </Typography>

            <TextField
              variant="outlined"
              select
              label="Base Currency"
              size="small"
              fullWidth
              required
              value={sourceCurrency}
              onChange={e => setSourceCurrency(e.target.value)}
              className={`${classes.marginStyle} ${classes.inputStyle}`}>
              {allCountry.map((e, index) => (
                <MenuItem value={e.currency} key={index}>
                  <Box className={classes.inner}>
                    <img src={e.flag} style={{ maxWidth: 24, marginRight: 10 }} alt="" /> {e.currency}
                  </Box>
                </MenuItem>
              ))}
            </TextField>
            <TextField
              label="USD to Source Rate"
              variant="outlined"
              fullWidth
              required
              size="small"
              className={`${classes.marginStyle} ${classes.inputStyle}`}
              value={usdToSourceRate}
              onChange={e => setUsdToSourceRate(e.target.value)}
            />
            <Button
              variant="contained"
              className={classes.buttonStyle}
              color="primary"
              disabled={loading}
              fullWidth
              onClick={handleSubmit}>
              {loading ? <CircularProgress size="1rem" style={{ marginRight: '10px' }} /> : null}
              Submit
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
};

export default BaseCurrencyConversion;
